module.exports = __webpack_public_path__ + "static/media/naa.1eb1ef0b.ogg";